import { Drawer } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "BusinessFilterLayout";
var classes = {
    wall: "".concat(PREFIX, "-wall"),
    sidebar: "".concat(PREFIX, "-sidebar"),
    sidebarPaper: "".concat(PREFIX, "-sidebarPaper")
};
var StyledBusinessFilterLayoutMobile = styled(Drawer, {})(function () { return ({
    "& .MuiDrawer-paper": {
        backgroundColor: "#F5F5F5",
        maxWidth: "calc(100% - 100px)"
    }
}); });

export { classes, StyledBusinessFilterLayoutMobile as default };
//# sourceMappingURL=mobile.styled.js.map
